<template>
  <!-- 房产详情 -->
  <div class="houseDetail">
    <div style="margin-top: 15px">
      <el-form label-width="120px" size="small" :inline="true">
        <el-card style="width: 95%; margintop: 20px; margin: 0 auto">
          <el-row>
            <el-col>
              <el-form-item label="楼盘名字" prop="name">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.name"
                  :disabled="disOpen"
                  class="ipt"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="开发商" prop="kaifashang">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.kaifashang"
                  :disabled="disOpen"
                  class="ipt"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8">
              <el-form-item label="销售阶段" prop="jieduanId">
                <el-select
                  v-model="detailData.jieduanId"
                  placeholder="请选择"
                  :disabled="disOpen"
                >
                  <el-option
                    v-for="item in xiaoData"
                    :key="item.value"
                    :label="item.name"
                    :value="item.enumeration"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="销售状态" prop="xiaoshouId">
                <el-select
                  v-model="detailData.xiaoshouId"
                  placeholder="请选择"
                  :disabled="disOpen"
                >
                  <el-option
                    v-for="item in xiaotai"
                    :key="item.value"
                    :label="item.name"
                    :value="item.enumeration"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="产权年限" prop="chanquanId">
                <el-select
                  v-model="detailData.chanquanId"
                  placeholder="请选择"
                  :disabled="disOpen"
                >
                  <el-option
                    v-for="item in chanData"
                    :key="item.value"
                    :label="item.name"
                    :value="item.enumeration"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- <el-col :span="8">
              <el-form-item label="按揭银行 " prop="bankId">
                <el-select
                  v-model="detailData.bankId"
                  placeholder="请选择"
                  :disabled="disOpen"
                >
                  <el-option
                    v-for="item in jieData"
                    :key="item.value"
                    :label="item.name"
                    :value="item.enumeration"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="项目简介" prop="jianjie">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.jianjie"
                  :disabled="disOpen"
                  class="xmjj setIpt"
                  type="textarea"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="楼盘地址" prop="address">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.address"
                  :disabled="disOpen"
                  class="xmjj setIpt"
                  type="textarea"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="售楼地址" prop="shoulou">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.shoulou"
                  :disabled="disOpen"
                  class="xmjj setIpt"
                  type="textarea"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col>
              <el-form-item label="车位数量+车位描述" prop="chewei">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.chewei"
                  :disabled="disOpen"
                  class="xmjj setIpt"
                  type="textarea"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 物业所有 -->
          <el-row>
            <!-- <el-col :span="8">
              <el-form-item label="物业顾问公司" prop="guwengongsi">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.guwengongsi"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="8">
              <el-form-item label="物业费（元/月）" prop="wuyefei">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.wuyefei"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="物业公司" prop="wuyegongsi">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.wuyegongsi"
                  :disabled="disOpen"
                  class="setIpt"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <!-- <el-form-item label="物业描述" prop="miaoshu">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.miaoshu"
                  :disabled="disOpen"
                  class="xmjj"
                ></el-input>
              </el-form-item> -->
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="均价" prop="junjia" class="flexForm">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.junjia"
                  :disabled="disOpen"
                ></el-input>
                （元）
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="报价日期" prop="baojiaDate">
                <el-date-picker
                  v-model="detailData.baojiaDate"
                  type="datetime"
                  placeholder="选择日期"
                  :disabled="disOpen"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="开盘时间" prop="kaipan">
                <el-date-picker
                  v-model="detailData.kaipan"
                  type="datetime"
                  placeholder="选择日期"
                  :disabled="disOpen"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item label="最高价" prop="zuigao">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.zuigao"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="最低价" prop="zuidi">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.zuidi"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row>
            <el-col :span="8">
              <!-- <el-form-item label="参考均价" prop="cankao">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.cankao"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item> -->
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item label="价格描述" prop="jiagemiao">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.jiagemiao"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="当前折扣" prop="zhekou">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.zhekou"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row>
            <!-- <el-col :span="8">
              <el-form-item label="入住时间" prop="ruzhu">
                <el-date-picker
                  v-model="detailData.ruzhu"
                  type="datetime"
                  placeholder="选择日期"
                  :disabled="disOpen"
                ></el-date-picker>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row>
            <!-- <el-col :span="8">
              <el-form-item label="开工时间" prop="kaigong">
                <el-date-picker
                  v-model="detailData.kaigong"
                  type="datetime"
                  placeholder="选择日期"
                  :disabled="disOpen"
                ></el-date-picker>
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="8">
              <el-form-item label="竣工时间" prop="jungong">
                <el-date-picker
                  v-model="detailData.jungong"
                  type="datetime"
                  placeholder="选择日期"
                  :disabled="disOpen"
                ></el-date-picker>
              </el-form-item>
            </el-col> -->
          </el-row>

          <el-row>
            <!-- <el-col :span="8">
              <el-form-item label="临时售楼地址" prop="linshi">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.linshi"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="售楼处电话" prop="phone">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.phone"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="区县" prop="quxian">
                <el-select
                  placeholder="请选择"
                  :disabled="disOpen"
                  v-model="detailData.quxian"
                >
                  <el-option
                    v-for="item in quData"
                    :key="item.value"
                    :label="item.name"
                    :value="item.enumeration"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="环线 " prop="huanxianId">
                <el-select
                  placeholder="请选择"
                  v-model="detailData.huanxianId"
                  :disabled="disOpen"
                >
                  <el-option
                    v-for="item in huanData"
                    :key="item.value"
                    :label="item.name"
                    :value="item.enumeration"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item label="别墅风格" prop="bieshuFenggeId">
                <el-select
                  v-model="detailData.bieshuFenggeId"
                  placeholder="请选择"
                  :disabled="disOpen"
                >
                  <el-option
                    v-for="item in shuData"
                    :key="item.value"
                    :label="item.name"
                    :value="item.enumeration"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="8">
              <el-form-item label="产权描述" prop="chanquanMiaoshu">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.chanquanMiaoshu"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>
          <!-- <el-row>
            <el-col :span="8">
              <el-form-item label="投资商" prop="touzishang">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.touzishang"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="承建商" prop="chengjianshang">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.chengjianshang"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="代理商" prop="dailishang">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.dailishang"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row>
            <el-col :span="8">
              <el-form-item label="容积率" prop="rongji" class="flexForm">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.rongji"
                  :disabled="disOpen"
                ></el-input>
                （%）
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="绿化率" prop="lvhua" class="flexForm">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.lvhua"
                  :disabled="disOpen"
                ></el-input>
                （%）
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="楼栋数" prop="loudong" class="flexForm">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.loudong"
                  :disabled="disOpen"
                ></el-input>
                （栋）
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- <el-col :span="8">
              <el-form-item label="已开发期数" prop="kaifa">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.kaifa"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="当前期数" prop="dangqian">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.dangqian"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row>
            <!-- <el-col :span="8">
              <el-form-item label="别名" prop="bieming">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.bieming"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="商圈" prop="shangquan">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.shangquan"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="总户数" prop="zonghu" class="flexForm">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.zonghu"
                  :disabled="disOpen"
                ></el-input>
                （户）
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="住宅类别" prop="zhuzhaileiId">
                <el-select
                  v-model="detailData.zhuzhaileiId"
                  placeholder="请选择"
                  :disabled="disOpen"
                >
                  <el-option
                    v-for="item in zhuData"
                    :key="item.value"
                    :label="item.name"
                    :value="item.enumeration"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="建筑类别（楼样式）" prop="jianzhulouId">
                <el-select
                  v-model="detailData.jianzhulouId"
                  placeholder="请选择"
                  :disabled="disOpen"
                >
                  <el-option
                    v-for="item in jianData"
                    :key="item.value"
                    :label="item.name"
                    :value="item.enumeration"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- <el-col :span="8">
              <el-form-item label="建筑类别（其他）" prop="jianzhulouOther">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.jianzhulouOther"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="8">
              <el-form-item label="建筑类别（层样式）" prop="jianzhucengId">
                <el-select
                  v-model="detailData.jianzhucengId"
                  placeholder="请选择"
                  :disabled="disOpen"
                >
                  <el-option
                    v-for="item in leiData"
                    :key="item.value"
                    :label="item.name"
                    :value="item.enumeration"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="建筑面积"
                prop="jianzhuMianji"
                class="flexForm"
              >
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.jianzhuMianji"
                  :disabled="disOpen"
                ></el-input>
                （㎡）
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="占地面积"
                prop="zhandiMianji"
                class="flexForm"
              >
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.zhandiMianji"
                  :disabled="disOpen"
                ></el-input>
                （㎡）
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item label="建筑类别层样式-其他说明" prop="jianzhucengOther">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.jianzhucengOther"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row>
            <!-- <el-col :span="8">
              <el-form-item label="别墅建筑类别" prop="bieshuTypeId">
                <el-select v-model="detailData.bieshuTypeId" placeholder="请选择" :disabled="disOpen">
                  <el-option
                    v-for="item in bieData"
                    :key="item.value"
                    :label="item.name"
                    :value="item.enumeration"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="8">
              <el-form-item label="别墅建筑类别“其他”说明" prop="bieshuTypeOther">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.bieshuTypeOther"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row>
            <!-- <el-col :span="8">
              <el-form-item label="项目简介" prop="jianjie">
                <el-input placeholder="请输入内容" v-model="detailData.jianjie" :disabled="disOpen"></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>

          <el-row> </el-row>

          <el-row>
            <el-col>
              <el-form-item label="楼层状况" prop="zhuangkuang">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.zhuangkuang"
                  :disabled="disOpen"
                  class="ipt setIpt"
                  type="textarea"
                ></el-input>
              </el-form-item>
            </el-col>

            <!-- <el-col :span="8">
              <el-form-item label="车位出售价格" prop="cheweiChushou">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.cheweiChushou"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row>
            <!-- <el-col :span="8">
              <el-form-item label="车位出租价格" prop="cheweiChuzu">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.cheweiChuzu"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col> -->

            <el-col :span="8">
              <el-form-item label="装修状况（字段表）" prop="zhuangxiuId">
                <el-select
                  placeholder="请选择"
                  v-model="detailData.zhuangxiuId"
                  :disabled="disOpen"
                >
                  <el-option
                    v-for="item in xiuData"
                    :key="item.value"
                    :label="item.name"
                    :value="item.enumeration"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item label="建筑及园林设计单位" prop="yuanlindanwei">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.yuanlindanwei"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>
          <!-- <el-row>
            <el-col :span="8">
              <el-form-item label="坐标-经度" prop="longitude">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.longitude"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="坐标-纬度" prop="latitude">
                <el-input
                  placeholder="请输入别名"
                  v-model="detailData.latitude"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="供电" prop="gongdian">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.gongdian"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->

          <!-- <el-row>
            <el-col :span="8">
              <el-form-item label="结构" prop="jiegou">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.jiegou"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="供气" prop="gongqi">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.gongqi"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="外墙" prop="waiqiang">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.waiqiang"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
          <!-- <el-row>
            <el-col :span="8">
              <el-form-item label="采暖" prop="cainuan">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.cainuan"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="内墙" prop="neiqiang">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.neiqiang"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="电梯" prop="dianti">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.dianti"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->

          <!-- <el-row>
            <el-col :span="8">
              <el-form-item label="通讯" prop="tongxun">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.tongxun"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="电梯服务户数" prop="hushu">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.hushu"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="门窗" prop="menchuang">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.menchuang"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->

          <!-- <el-row>
            <el-col :span="8">
              <el-form-item label="卫生间" prop="weishengjian">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.weishengjian"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="大堂" prop="datang">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.datang"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="厨房" prop="chufang">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.chufang"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
          <!-- <el-row>
            <el-col :span="8">
              <el-form-item label="首层大堂墙面" prop="qiangmian">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.qiangmian"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="卧室地面" prop="dimian">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.dimian"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="地面材料" prop="cailiao">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.cailiao"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->

          <!-- <el-row>
            <el-col :span="8">
              <el-form-item label="电梯间" prop="diantijian">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.diantijian"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="室内涂料" prop="tuliao">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.tuliao"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="公共走廊，消防楼" prop="zoulang">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.zoulang"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
          <!-- <el-row>
            <el-col :span="8">
              <el-form-item label="门禁" prop="menjin">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.menjin"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="电梯间墙面" prop="tiQiangmian">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.tiQiangmian"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="信报箱" prop="xinbaoxiang">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.xinbaoxiang"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->

          <!-- <el-row>
            <el-col :span="8">
              <el-form-item label="电视系统" prop="dianshi">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.dianshi"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="中水系统" prop="zhongshui">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.zhongshui"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="空调系统" prop="kongtiao">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.kongtiao"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
          <!-- <el-row>
            <el-col :span="8">
              <el-form-item label="安防系统" prop="anfang">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.anfang"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="电子围栏" prop="weilan">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.weilan"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="交通" prop="jiaotong">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.jiaotong"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
          <!-- <el-row>
            <el-col :span="8">
              <el-form-item label="周边设施" prop="zhoubian">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.zhoubian"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="小区内部配套" prop="neibu">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.neibu"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="标签" prop="biaoqian">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.biaoqian"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
          <!-- <el-row>
            <el-col :span="8">
              <el-form-item label="景观设计单位" prop="jingguansheiji">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.jingguansheiji"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="整合推广单位" prop="tuiguang">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.tuiguang"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="平面媒体广告单位" prop="pingmianmeiti">
                <el-input
                  placeholder="请输入内容"
                  v-model="detailData.pingmianmeiti"
                  :disabled="disOpen"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
          <!-- <el-row>
            <el-form-item label="评分" prop="sore">
              <a-input-number :min="0" :max="10" :step="0.1" @change="onChange" :disabled="disOpen" :value="detailData.score" style="width:100px"/>
              </el-form-item>
          </el-row> -->
          <!-- <el-row>
            <el-form-item label="轮播">
              <el-radio-group
                v-model="detailData.isRotation"
                style=" margin-top: 10px"
                :disabled="disOpen"
              >
                <el-radio :label="1" value="1">轮播</el-radio>
                <el-radio :label="2" value="2">置顶</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-row> -->

          <el-row>
            <el-form-item label="推荐猜你喜欢">
              <el-radio-group
                v-model="detailData.isLike"
                style="width: 100%; margin-top: 10px"
                :disabled="disOpen"
              >
                <el-radio :label="0" value="0">不推荐</el-radio>
                <el-radio :label="1" value="1">推荐</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="热门房产">
              <el-radio-group
                v-model="detailData.isHot"
                style="width: 100%; margin-top: 10px"
                :disabled="disOpen"
              >
                <el-radio :label="1" value="1">是</el-radio>
                <el-radio :label="0" value="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-row>
          <el-row>
            <div class="map">
              <div id="container"></div>
              <input
                id="tipinput"
                class="form-control input-style"
                placeholder="请输入关键字"
                value=""
              />
              <div class="input-card">
                <h4>经纬度：</h4>
                <div class="input-item">
                  <input
                    type="text"
                    readonly="true"
                    class="form-control input-style"
                    id="lnglat"
                  />
                </div>
              </div>
            </div>
          </el-row>

          <!-- <el-row>
            <el-form-item label="封面图样式">
              <el-radio-group
                v-model="detailData.floorType"
                style="width: 100%; margin-top: 10px"
                :disabled="disOpen"
              >
                <el-radio :label="1" value="1">一张小图</el-radio>
                <el-radio :label="2" value="2">三张小图</el-radio>
                <el-radio :label="3" value="3">一张大图</el-radio>
              </el-radio-group>
              <div
                style="width: 100%; position: relative; left: -10px; top: 5px"
              >
                <img
                  src="https://news-icon.oss-cn-beijing.aliyuncs.com/news_type_1.png"
                  style="width: 100px; height: 100px"
                />
                <img
                  src="https://news-icon.oss-cn-beijing.aliyuncs.com/news_type_3.png"
                  style="width: 100px; height: 100px; margin-left: 10px"
                />
                <img
                  src="https://news-icon.oss-cn-beijing.aliyuncs.com/news_type_2.png"
                  style="width: 100px; height: 100px; margin-left: 10px"
                />
              </div>
            </el-form-item>
          </el-row> -->
          <el-row>
            <el-col
              :span="12"
              style="marginleft: 20px; marginbottom: 20px; margintop: 20px"
            >
              <el-button
                type="primary"
                @click="detailEdit"
                v-if="menuPerm('newfloor:edit')"
                >编辑</el-button
              >
              <el-button
                type="primary"
                @click="submitEdit"
                v-if="menuPerm('newfloor:edit')"
                >保存</el-button
              >
            </el-col>
          </el-row>
        </el-card>
        <el-card style="width: 95%; margintop: 20px; margin: 20px auto">
          <el-row>
            <el-form-item label="销售许可">
              <el-table
                :data="salesDatas"
                style="width: 100%"
                :row-style="{ height: '50px' }"
                :cell-style="{ padding: '0' }"
              >
                <el-table-column
                  prop="salesNumber"
                  label="许可证号"
                  width="180"
                >
                  <template slot-scope="{ row }">
                    <span>{{ row.salesNumber }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="bindBuiding"
                  label="绑定楼号"
                  width="180"
                >
                  <template slot-scope="{ row }">
                    <span>{{ row.bindBuiding }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="address" label="操作" width="300">
                  <template slot-scope="{ row, $index }">
                    <el-button
                      type="primary"
                      v-if="$index == salesDatas.length - 1"
                      @click="xiaoAdd"
                      >添加</el-button
                    >

                    <el-button type="primary" @click="handleDetail(row.id)"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <el-row style="margintop: 20px">
                <el-button
                  type="primary"
                  @click="xiaoAdd"
                  v-if="salesDatas == ''"
                  >添加</el-button
                >
              </el-row>
            </el-form-item>
          </el-row>
        </el-card>
        <el-card style="width: 95%; margintop: 20px; margin: 20px auto">
          <el-row>
            <el-form-item label="户型(1200*600)">
              <div class="house_box">
                <div
                  class="house_one"
                  v-for="(item, index) in houseDatas"
                  :key="index"
                  style="margintop: 20px"
                >
                  <div class="house_img">
                    <img :src="item.imgUrl" alt />
                  </div>
                  <div class="house_message">
                    <el-row>
                      <el-col :span="8">
                        <span>{{ item.room }}</span
                        >室
                      </el-col>
                      <el-col :span="8">
                        <span>{{ item.office }}</span
                        >厅
                      </el-col>
                      <el-col :span="8">
                        <span>{{ item.toilet }}</span
                        >卫
                      </el-col>
                    </el-row>
                    <el-row>
                      单价：
                      <span>{{ item.price }}</span
                      >元/㎡
                    </el-row>
                    <el-row>
                      总面积：
                      <span>{{ item.size }}</span
                      >㎡
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-button
                          type="primary"
                          @click="houseAdd"
                          v-if="index == houseDatas.length - 1"
                          >新增</el-button
                        >
                      </el-col>
                      <el-col :span="6">
                        <el-button type="primary" @click="houseDel(item.id)"
                          >删除</el-button
                        >
                      </el-col>
                    </el-row>
                    <el-row> </el-row>
                  </div>
                </div>

                <div
                  class="house_add"
                  v-show="houseOpen"
                  style="margintop: 20px"
                >
                  <div class="house_img">
                    <el-upload
                      class="avatar-uploader"
                      action="https://jsonplaceholder.typicode.com/posts/"
                      :show-file-list="false"
                      :on-change="handlehouseUpt"
                      :on-success="handleHouseSuccess"
                      :before-upload="beforeUpload"
                    >
                      <img v-if="imgHouse" :src="imgHouse" class="avatar" />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      <!-- <i  class="el-icon-plus avatar-uploader-icon"></i> -->
                    </el-upload>
                  </div>
                  <div class="house_message">
                    <el-row style="marginleft: 0">
                      <el-col :span="8">
                        <el-input
                          style="width: 45px"
                          v-model="houseAddDatas.room"
                        ></el-input
                        >室
                      </el-col>
                      <el-col :span="8">
                        <el-input
                          style="width: 45px"
                          v-model="houseAddDatas.office"
                        ></el-input
                        >厅
                      </el-col>
                      <el-col :span="8">
                        <el-input
                          style="width: 45px"
                          v-model="houseAddDatas.toilet"
                        ></el-input
                        >卫
                      </el-col>
                    </el-row>

                    <el-row>
                      单价：
                      <el-input
                        style="width: 100px"
                        v-model="houseAddDatas.price"
                      ></el-input
                      >元/㎡
                    </el-row>
                    <el-row>
                      总面积：
                      <el-input
                        style="width: 100px"
                        v-model="houseAddDatas.size"
                      ></el-input
                      >㎡
                    </el-row>
                    <el-row>
                      <el-col :span="8">
                        <el-button type="primary" @click="submitAdd"
                          >确认新增</el-button
                        >
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </div>
              <el-row style="margintop: 20px; marginleft: 20px">
                <el-button type="primary" @click="huAdd" v-if="houseDatas == ''"
                  >添加</el-button
                >
              </el-row>
            </el-form-item>
          </el-row>
        </el-card>
        <el-card style="width: 95%; margintop: 20px; margin: 20px auto">
          <el-row>
            <el-form-item label="置业经理">
              <el-button
                type="primary"
                style="marginleft: 120px"
                @click="handleZhi"
                >关联置业经理</el-button
              >

              <div class="manage_box">
                <div
                  class="manage_one"
                  v-for="(item, index) in manageDatas"
                  :key="index"
                  style="margintop: 20px"
                >
                  <div class="manage_img">
                    <img :src="item.photoUrl" alt />
                  </div>
                  <div class="manage_message">
                    <el-row>
                      姓名：
                      <span>{{ item.name }}</span>
                    </el-row>
                    <el-row>
                      手机号：
                      <span>{{ item.phone }}</span>
                    </el-row>
                    <el-row>
                      微信：
                      <viewer>
                        <img :src="item.wechat" style="width: 50px" />
                      </viewer>
                      <!-- <img :src="item.wechat" alt="" style="width:50px"> -->
                      <!-- <span>{{ item.wechat }}</span> -->
                    </el-row>
                    <el-row>
                      邮箱：
                      <span>{{ item.email }}</span>
                    </el-row>
                    <el-row>
                      <el-button
                        type="primary"
                        style="marginbottom: 20px"
                        @click="zhiDel(item.id)"
                        >删除</el-button
                      >
                    </el-row>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-row>
        </el-card>
        <el-card style="width: 95%; margintop: 20px; margin: 20px auto">
          <el-row>
            <el-form-item label="楼盘相册">
              <el-row>
                <el-form-item label="封面图(300*170)">
                  <el-row
                    style="width: 90%; position: relative; marginleft: 100px"
                  >
                    <div style="display: flex; flex-wrap: wrap">
                      <div
                        class="logoUg"
                        v-for="(item, index) in imgFeng"
                        :key="index"
                        style="margin: 15px 20px; position: relative"
                      >
                        <img :src="item.imgUrl" alt class="imgfir" />
                        <div
                          style="
                            width: 150px;
                            height: 100%;
                            position: absolute;
                            background: rgba(0, 0, 0, 0.6);
                            top: 0;
                          "
                          class="delimg"
                          @click="phoneDel(item.id)"
                          ref="imgDelete"
                        >
                          <i
                            class="el-icon-delete"
                            style="
                              position: absolute;
                              top: 45%;
                              left: 45%;
                              font-size: 22px;
                              color: #fff;
                            "
                            :size="50"
                          ></i>
                        </div>
                      </div>
                      <div style="margin: 15px 20px">
                        <el-upload
                          :auto-upload="false"
                          :file-list="fengUptImg"
                          :on-change="handleFengUpt"
                          :on-exceed="handleExceed"
                          :on-remove="removeFeng"
                          :on-success="handleSuccess"
                          action="https://jsonplaceholder.typicode.com/posts/"
                          list-type="picture-card"
                          ref="fengImg"
                          multiple
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                      </div>
                    </div>
                  </el-row>
                </el-form-item>
              </el-row>
              <el-row>
                <el-button
                  @click="FengUpt"
                  v-preventClick
                  class="upLoadBtn"
                  type="primary"
                  >确认上传</el-button
                >
              </el-row>
              <a-divider type="horizontal" :dashed="true" />

              <el-row>
                <el-form-item label="周边配套图(981*620)">
                  <el-row
                    style="width: 90%; position: relative; marginleft: 100px"
                  >
                    <div style="display: flex; flex-wrap: wrap">
                      <div
                        class="logoUg"
                        v-for="(item, index) in imgZhou"
                        :key="index"
                        style="margin: 15px 20px; position: relative"
                      >
                        <img :src="item.imgUrl" alt class="imgfir" />
                        <div
                          style="
                            width: 150px;
                            height: 100%;
                            position: absolute;
                            background: rgba(0, 0, 0, 0.6);
                            top: 0;
                          "
                          class="delimg"
                          @click="phoneDel(item.id)"
                          ref="imgDelete"
                        >
                          <i
                            class="el-icon-delete"
                            style="
                              position: absolute;
                              top: 45%;
                              left: 45%;
                              font-size: 22px;
                              color: #fff;
                            "
                            :size="50"
                          ></i>
                        </div>
                      </div>

                      <div style="margin: 15px 20px">
                        <el-upload
                          :auto-upload="false"
                          :file-list="zhouUptImg"
                          :on-change="handlezhouUpt"
                          :on-exceed="handleExceed"
                          :on-remove="removeZhou"
                          :on-success="handleSuccess"
                          action="https://jsonplaceholder.typicode.com/posts/"
                          list-type="picture-card"
                          ref="zhouImg"
                          multiple
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                      </div>
                    </div>
                  </el-row>
                </el-form-item>
              </el-row>
              <el-row>
                <el-button
                  @click="ZhouUpt"
                  v-preventClick
                  class="upLoadBtn"
                  type="primary"
                  >确认上传</el-button
                >
              </el-row>
              <a-divider type="horizontal" :dashed="true" />
              <el-row>
                <el-form-item label="现场项目图(981*620)">
                  <el-row
                    style="width: 90%; position: relative; marginleft: 100px"
                  >
                    <div style="display: flex; flex-wrap: wrap">
                      <div
                        class="logoUg"
                        v-for="(item, index) in imgXian"
                        :key="index"
                        style="margin: 15px 20px; position: relative"
                      >
                        <img :src="item.imgUrl" alt class="imgfir" />
                        <div
                          style="
                            width: 150px;
                            height: 100%;
                            position: absolute;
                            background: rgba(0, 0, 0, 0.6);
                            top: 0;
                          "
                          class="delimg"
                          @click="phoneDel(item.id)"
                          ref="imgDelete"
                        >
                          <i
                            class="el-icon-delete"
                            style="
                              position: absolute;
                              top: 45%;
                              left: 45%;
                              font-size: 22px;
                              color: #fff;
                            "
                            :size="50"
                          ></i>
                        </div>
                      </div>

                      <div style="margin: 15px 10px">
                        <el-upload
                          :auto-upload="false"
                          :file-list="xianUptImg"
                          :on-change="handlexianUpt"
                          :on-exceed="handleExceed"
                          :on-remove="removeXian"
                          :on-success="handleSuccess"
                          action="https://jsonplaceholder.typicode.com/posts/"
                          list-type="picture-card"
                          ref="xianImg"
                          multiple
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                      </div>
                    </div>
                  </el-row>
                </el-form-item>
              </el-row>
              <el-row>
                <el-button
                  @click="XianUpt"
                  v-preventClick
                  class="upLoadBtn"
                  type="primary"
                  >确认上传</el-button
                >
              </el-row>
              <a-divider type="horizontal" :dashed="true" />
              <el-row>
                <el-form-item label="样板间图(981*620)">
                  <el-row
                    style="width: 90%; position: relative; marginleft: 100px"
                  >
                    <div style="display: flex; flex-wrap: wrap">
                      <div
                        class="logoUg"
                        v-for="(item, index) in imgYang"
                        :key="index"
                        style="margin: 15px 20px; position: relative"
                      >
                        <img :src="item.imgUrl" alt class="imgfir" />
                        <div
                          style="
                            width: 150px;
                            height: 100%;
                            position: absolute;
                            background: rgba(0, 0, 0, 0.6);
                            top: 0;
                          "
                          class="delimg"
                          @click="phoneDel(item.id)"
                          ref="imgDelete"
                        >
                          <i
                            class="el-icon-delete"
                            style="
                              position: absolute;
                              top: 45%;
                              left: 45%;
                              font-size: 22px;
                              color: #fff;
                            "
                            :size="50"
                          ></i>
                        </div>
                      </div>

                      <div style="margin: 15px 20px">
                        <el-upload
                          :auto-upload="false"
                          :file-list="yangUptImg"
                          :on-change="handleyangUpt"
                          :on-exceed="handleExceed"
                          :on-remove="removeYang"
                          :on-success="handleSuccess"
                          action="https://jsonplaceholder.typicode.com/posts/"
                          list-type="picture-card"
                          ref="yangImg"
                          multiple
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                      </div>
                    </div>
                  </el-row>
                </el-form-item>
              </el-row>
              <el-row>
                <el-button
                  @click="YangUpt"
                  v-preventClick
                  class="upLoadBtn"
                  type="primary"
                  >确认上传</el-button
                >
              </el-row>
              <a-divider type="horizontal" :dashed="true" />
              <el-row>
                <el-form-item label="效果图(981*620)">
                  <el-row
                    style="width: 90%; position: relative; marginleft: 100px"
                  >
                    <div style="display: flex; flex-wrap: wrap">
                      <div
                        class="logoUg"
                        v-for="(item, index) in imgXiao"
                        :key="index"
                        style="margin: 15px 20px; position: relative"
                      >
                        <img :src="item.imgUrl" alt class="imgfir" />
                        <div
                          style="
                            width: 150px;
                            height: 100%;
                            position: absolute;
                            background: rgba(0, 0, 0, 0.6);
                            top: 0;
                          "
                          class="delimg"
                          @click="phoneDel(item.id)"
                          ref="imgDelete"
                        >
                          <i
                            class="el-icon-delete"
                            style="
                              position: absolute;
                              top: 45%;
                              left: 45%;
                              font-size: 22px;
                              color: #fff;
                            "
                            :size="50"
                          ></i>
                        </div>
                      </div>

                      <div style="margin: 15px 20px">
                        <el-upload
                          :auto-upload="false"
                          :file-list="xiaoUptImg"
                          :on-change="handlexiaoUpt"
                          :on-exceed="handleExceed"
                          :on-remove="removeXiao"
                          :on-success="handleSuccess"
                          action="https://jsonplaceholder.typicode.com/posts/"
                          list-type="picture-card"
                          ref="xiaoImg"
                          multiple
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                      </div>
                    </div>
                  </el-row>
                </el-form-item>
              </el-row>
              <el-row>
                <el-button
                  @click="XiaoUpt"
                  v-preventClick
                  class="upLoadBtn"
                  type="primary"
                  >确认上传</el-button
                >
              </el-row>
              <a-divider type="horizontal" :dashed="true" />
              <el-row>
                <el-form-item label="实景图(981*620)">
                  <el-row
                    style="width: 90%; position: relative; marginleft: 100px"
                  >
                    <div style="display: flex; flex-wrap: wrap">
                      <div
                        class="logoUg"
                        v-for="(item, index) in imgShi"
                        :key="index"
                        style="margin: 15px 20px; position: relative"
                      >
                        <img :src="item.imgUrl" alt class="imgfir" />
                        <div
                          style="
                            width: 150px;
                            height: 100%;
                            position: absolute;
                            background: rgba(0, 0, 0, 0.6);
                            top: 0;
                          "
                          class="delimg"
                          @click="phoneDel(item.id)"
                          ref="imgDelete"
                        >
                          <i
                            class="el-icon-delete"
                            style="
                              position: absolute;
                              top: 45%;
                              left: 45%;
                              font-size: 22px;
                              color: #fff;
                            "
                            :size="50"
                          ></i>
                        </div>
                      </div>

                      <div style="margin: 15px 20px">
                        <el-upload
                          :auto-upload="false"
                          :file-list="shiUptImg"
                          :on-change="handleshiUpt"
                          :on-exceed="handleExceed"
                          :on-remove="removeShi"
                          :on-success="handleSuccess"
                          action="https://jsonplaceholder.typicode.com/posts/"
                          list-type="picture-card"
                          ref="shiImg"
                          multiple
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                      </div>
                    </div>
                  </el-row>
                </el-form-item>
              </el-row>
              <el-row>
                <el-button
                  @click="ShiUpt"
                  v-preventClick
                  class="upLoadBtn"
                  type="primary"
                  >确认上传</el-button
                >
              </el-row>
              <a-divider type="horizontal" :dashed="true" />
              <el-row>
                <el-form-item label="外景图(981*620)">
                  <el-row
                    style="width: 90%; position: relative; marginleft: 100px"
                  >
                    <div style="display: flex; flex-wrap: wrap">
                      <div
                        class="logoUg"
                        v-for="(item, index) in imgWai"
                        :key="index"
                        style="margin: 15px 20px; position: relative"
                      >
                        <img :src="item.imgUrl" alt class="imgfir" />
                        <div
                          style="
                            width: 150px;
                            height: 100%;
                            position: absolute;
                            background: rgba(0, 0, 0, 0.6);
                            top: 0;
                          "
                          class="delimg"
                          @click="phoneDel(item.id)"
                          ref="imgDelete"
                        >
                          <i
                            class="el-icon-delete"
                            style="
                              position: absolute;
                              top: 45%;
                              left: 45%;
                              font-size: 22px;
                              color: #fff;
                            "
                            :size="50"
                          ></i>
                        </div>
                      </div>

                      <div style="margin: 15px 20px">
                        <el-upload
                          :auto-upload="false"
                          :file-list="waiUptImg"
                          :on-change="handlewaiUpt"
                          :on-exceed="handleExceed"
                          :on-remove="removeWai"
                          :on-success="handleSuccess"
                          action="https://jsonplaceholder.typicode.com/posts/"
                          list-type="picture-card"
                          ref="waiImg"
                          multiple
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                      </div>
                    </div>
                  </el-row>
                </el-form-item>
              </el-row>
              <el-row>
                <el-button
                  @click="WaiUpt"
                  v-preventClick
                  class="upLoadBtn"
                  type="primary"
                  >确认上传</el-button
                >
              </el-row>
              <a-divider type="horizontal" :dashed="true" />
              <el-row>
                <el-form-item label="交通图(981*620)">
                  <el-row
                    style="width: 90%; position: relative; marginleft: 100px"
                  >
                    <div style="display: flex; flex-wrap: wrap">
                      <div
                        class="logoUg"
                        v-for="(item, index) in imgJiao"
                        :key="index"
                        style="margin: 15px 20px; position: relative"
                      >
                        <img :src="item.imgUrl" alt class="imgfir" />
                        <div
                          style="
                            width: 150px;
                            height: 100%;
                            position: absolute;
                            background: rgba(0, 0, 0, 0.6);
                            top: 0;
                          "
                          class="delimg"
                          @click="phoneDel(item.id)"
                          ref="imgDelete"
                        >
                          <i
                            class="el-icon-delete"
                            style="
                              position: absolute;
                              top: 45%;
                              left: 45%;
                              font-size: 22px;
                              color: #fff;
                            "
                            :size="50"
                          ></i>
                        </div>
                      </div>

                      <div style="margin: 15px 20px">
                        <el-upload
                          :auto-upload="false"
                          :file-list="jiaoUptImg"
                          :on-change="handlejiaoUpt"
                          :on-exceed="handleExceed"
                          :on-remove="removeJiao"
                          :on-success="handleSuccess"
                          action="https://jsonplaceholder.typicode.com/posts/"
                          list-type="picture-card"
                          ref="jiaoImg"
                          multiple
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                      </div>
                    </div>
                  </el-row>
                </el-form-item>
              </el-row>
              <el-row>
                <el-button
                  @click="JiaoUpt"
                  v-preventClick
                  class="upLoadBtn"
                  type="primary"
                  >确认上传</el-button
                >
              </el-row>
              <a-divider type="horizontal" :dashed="true" />
              <el-row>
                <el-form-item label="轮播图(981*552)">
                  <el-row
                    style="width: 90%; position: relative; marginleft: 100px"
                  >
                    <div style="display: flex; flex-wrap: wrap">
                      <div
                        class="logoUg"
                        v-for="(item, index) in imgLun"
                        :key="index"
                        style="margin: 15px 20px; position: relative"
                      >
                        <img :src="item.imgUrl" alt class="imgfir" />
                        <div
                          style="
                            width: 150px;
                            height: 100%;
                            position: absolute;
                            background: rgba(0, 0, 0, 0.6);
                            top: 0;
                          "
                          class="delimg"
                          @click="phoneDel(item.id)"
                          ref="imgDelete"
                        >
                          <i
                            class="el-icon-delete"
                            style="
                              position: absolute;
                              top: 45%;
                              left: 45%;
                              font-size: 22px;
                              color: #fff;
                            "
                            :size="50"
                          ></i>
                        </div>
                      </div>

                      <div style="margin: 15px 20px">
                        <el-upload
                          ref="lunImg"
                          :auto-upload="false"
                          :file-list="lunUptImg"
                          :on-change="handlelunUpt"
                          :on-exceed="handleExceed"
                          :on-remove="removeLun"
                          :on-success="handleSuccess"
                          action="https://jsonplaceholder.typicode.com/posts/"
                          list-type="picture-card"
                          multiple
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                      </div>
                    </div>
                  </el-row>
                </el-form-item>
              </el-row>
              <el-row>
                <el-button
                  @click="LunUpt"
                  v-preventClick
                  class="upLoadBtn"
                  type="primary"
                  >确认上传</el-button
                >
              </el-row>
              <a-divider type="horizontal" :dashed="true" />
            </el-form-item>
          </el-row>
        </el-card>
        <el-card style="width: 95%; margintop: 20px; margin: 20px auto">
          <el-row>
            <el-form-item label="楼盘动态">
              <el-form
                label-width="80px"
                class="demo-ruleForm"
                :label-position="labelPosition"
              >
                <div style="display: flex; flex-wrap: wrap; marginleft: 100px">
                  <div
                    v-for="(item, index) in floorDatas"
                    :key="index"
                    style="
                      border: 1px solid #eee;
                      margin: 10px 10px;
                      width: 300px;
                    "
                  >
                    <el-row>
                      <el-form-item label="标题">
                        <el-input v-model="item.title"></el-input>
                      </el-form-item>
                    </el-row>
                    <el-row>
                      <el-form-item label="标签">
                        <el-input v-model="item.tag"></el-input>
                      </el-form-item>
                    </el-row>
                    <el-row>
                      <el-form-item label="内容">
                        <el-input v-model="item.message"></el-input>
                      </el-form-item>
                    </el-row>
                    <el-row>
                      <el-col :span="8" style="margin: 20px 20px">
                        <el-button type="primary" @click="floorDel(item.id)"
                          >删除</el-button
                        >
                      </el-col>
                      <el-col :span="8" style="margin: 20px 0px">
                        <el-button
                          type="primary"
                          @click="floorAdd(item.id)"
                          v-if="index == floorDatas.length - 1"
                          >新增</el-button
                        >
                      </el-col>
                    </el-row>
                  </div>
                  <div
                    style="
                      border: 1px solid #eee;
                      margin: 10px 10px;
                      width: 300px;
                    "
                    v-show="flooraddOpen"
                  >
                    <el-row>
                      <el-form-item label="标题">
                        <el-input v-model="flooraddData.title"></el-input>
                      </el-form-item>
                    </el-row>
                    <el-row>
                      <el-form-item label="标签">
                        <el-input v-model="flooraddData.tag"></el-input>
                      </el-form-item>
                    </el-row>
                    <el-row>
                      <el-form-item label="内容">
                        <el-input v-model="flooraddData.message"></el-input>
                      </el-form-item>
                    </el-row>
                    <el-row>
                      <el-col :span="8" style="margin: 20px 20px">
                        <el-button type="primary" @click="floorQue"
                          >保存</el-button
                        >
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-form>
              <el-row>
                <el-button
                  type="primary"
                  @click="louAdd"
                  style="margintop: 20px; marginleft: 20px"
                  v-if="floorDatas == ''"
                  >添加</el-button
                >
              </el-row>
            </el-form-item>
          </el-row>
        </el-card>

        <el-card style="width: 95%; margintop: 20px; margin: 20px auto">
          <el-form-item label="地铁">
            <div class="car_box">
              <div class="car_gui" ref="carHorse">
                <div
                  v-for="(item, index) in horData"
                  :key="index"
                  id="car_hor"
                  @click="handleCar(item.metroName, index)"
                  :class="[selectLi == index ? 'on' : '']"
                >
                  {{ item.metroName }}
                </div>
              </div>
              <div class="car_lu" v-show="carOpen">
                <div v-for="(item, index) in carData" :key="index" id="cars">
                  <span
                    :class="{ active: item.floorId != null }"
                    @click="
                      item.floorId != null
                        ? handleDel(item.id)
                        : handleAdd(item.id)
                    "
                    >{{ item.siteName }}</span
                  >
                </div>
              </div>
            </div>
          </el-form-item>
        </el-card>
      </el-form>
    </div>
    <!-- </el-card> -->
    <!-- 销售许可弹框 -->
    <a-modal
      title="销售许可"
      :visible="sclasvalibity"
      @ok="handleOk"
      @cancel="handleCancel"
      ok-text="保存"
      cancel-text="取消"
    >
      <el-form>
        <el-row>
          <el-form-item label="许可证号">
            <el-input
              style="width: 90%"
              v-model="moreDatas.salesNumber"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="绑定楼号">
            <el-input
              style="width: 90%"
              v-model="moreDatas.bindBuiding"
            ></el-input>
          </el-form-item>
        </el-row>
      </el-form>
    </a-modal>

    <!-- 置业经理弹框 -->
    <a-modal
      title="置业经理"
      :visible="messagealibity"
      @ok="handleYes"
      @cancel="handleCancel"
      ok-text="确定"
      cancel-text="取消"
    >
      <ul class="uls">
        <li
          v-for="(item, index) in manageName"
          :key="index"
          @click="messAdd(item.id, index)"
          :class="inds == index ? 'ons' : ''"
        >
          {{ item.name }}
        </li>
      </ul>
    </a-modal>
  </div>
</template>
<script>
import $ from "jquery";
var fengList = [],
  zhouList = [],
  xianList = [],
  yangList = [],
  xiaoList = [],
  shiList = [],
  waiList = [],
  jiaoList = [],
  lunList = [];
export default {
  data() {
    return {
      inds: "", //置业经理下标
      disOpen: true, //禁用状态
      floorName: "", //楼层名字
      labelPosition: "right",
      loading: false,
      imageUrl: "",
      // hourseImg:[],//上传户型
      messagealibity: false, //置业经理弹框
      manageName: "", //置业名字弹框
      messId: "", //置业弹框id
      houseUptImg: [], //上传户型
      houseUrl: [], //上传户型-------------------------
      fengUrl: [], //封面图上传-------------
      fengUptImg: [], //封面图上传------------
      zhouUrl: [], ////封面图上传-----------------------
      zhouUptImg: [], ////封面图上传------------
      xianUrl: [], //现场图上传-------------
      xianUptImg: [], //现场图上传--
      yangUrl: [], //样板图上传---------------
      yangUptImg: [], //样板图上传---
      xiaoUptImg: [], //效果图上传-----
      xiaoUrl: [], //效果图上传-----
      shiUptImg: [], //实景图上传-----
      shiUrl: [], //实景图上传-----
      waiUptImg: [], //外景图上传-----
      waiUrl: [], //外景图上传-----
      jiaoUptImg: [], //交通图上传-----
      jiaoUrl: [], //交通图上传-----
      lunUptImg: [], //轮播图上传-----
      lunUrl: [], //轮播图上传-----
      sclasvalibity: false, //销售弹框
      houseOpen: false, //户型新增

      value: "",
      detailData: "", //详情列表的数据
      salesDatas: [], //销售的数据
      houseDatas: "", //户型数据
      moreDatas: {
        //销售添加
        salesNumber: "",
        bindBuiding: "",
      },
      //户型新增数据
      houseAddDatas: {
        room: "", //室的数量
        office: "", //厅的数量
        toilet: "", //卫生间的数量
        price: "", //价格
        size: "", //面积
        branch: "",
      },
      manageDatas: "", //置业经理数据
      imgFeng: "", //封面图
      imgZhou: "", //周边配套图
      imgXian: "", //现场项目图
      imgYang: "", //样板间图,
      imgXiao: "", //效果图
      imgShi: "", //实景图
      imgWai: "", //外景图
      imgJiao: "", //交通图
      imgLun: "", //轮播图
      floorDatas: "", //楼层数据
      flooraddData: {
        //楼层新增
        title: "",
        tag: "",
        message: "",
      },
      flooraddOpen: false, //楼层新增弹框
      carData: "", //地铁的数据
      horData: "", //几号线
      houseCar: "", //几号线的参数
      carOpen: "", //地铁线路展示
      cars: "", //点击的几号线
      selectLi: "", //点击几号线的下标
      // fircar:'',//1号线
      // sencar:'',//2号线
      // thircar:'',//3号线
      // fourcar:'',//4号线
      // fivec

      // ----------下拉------------
      quData: "", //区县---下拉
      huanData: "", //环形--下拉
      zhuData: "", //住宅--下拉
      jieData: "", //按揭银行 id【下拉框】
      xiaoData: "", //销售阶段（字段表）【下拉框】
      xiaotai: "", //销售状态（字典表）【下拉框】

      xiuData: "", //装修状况（字段表）【下拉框】
      shuData: "", ////别墅风格（字典表）【下拉框】
      bieData: "", //别墅建筑类别【下拉框】

      leiData: "", //建筑类别（层样式）（字典表）【下拉框】
      jianData: "", //建筑类别
      chanData: "", //产权年限--下拉
      // =====================================
      loading: false,
      imgHouse: "", //户型上传,
    };
  },
  props: ["Detaildata"],
  methods: {
    onChange(val) {
      this.detailData.score = val;
    },
    beforeUpload(file, fileList) {
      return new Promise((resolve) => {
        // 图片压缩
        let reader = new FileReader(),
          img = new Image();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
          img.src = e.target.result;
        };

        img.onload = function () {
          let canvas = document.createElement("canvas");
          let context = canvas.getContext("2d");
          let width = "100";
          let height = "100";
          let originWidth = width;
          let originHeight = height;

          canvas.width = originWidth;
          canvas.height = originHeight;

          context.clearRect(0, 0, originWidth, originHeight);
          context.drawImage(img, 0, 0, originWidth, originHeight);

          canvas.toBlob(
            (blob) => {
              let imgFile = new File([blob], file.name, { type: file.type }); // 将blob对象转化为图片文件
              resolve(imgFile);
            },
            file.type,
            0.2
          ); // file压缩的图片类型
        };
      });
    },

    //转时间
    addZero(num) {
      return num < 10 ? "0" + num : num;
    },
    //转时间
    formatDateTime(date) {
      if (date == null) {
        return;
      } else {
        const time = new Date(Date.parse(date));
        time.setTime(time.setHours(time.getHours() + 8));
        const Y = time.getFullYear() + "-";
        const M = this.addZero(time.getMonth() + 1) + "-";
        const D = this.addZero(time.getDate()) + " ";
        const h = this.addZero(time.getHours()) + ":";
        const m = this.addZero(time.getMinutes()) + ":";
        const s = this.addZero(time.getSeconds());
        return Y + M + D + h + m + s;
      }
    },
    //详情编辑：
    detailEdit() {
      this.disOpen = false;
    },
    //编辑保存：
    submitEdit() {
      var id = this.Detaildata;
      this.detailData.longitude = document
        .getElementById("lnglat")
        .value.split(",")[0];
      this.detailData.latitude = document
        .getElementById("lnglat")
        .value.split(",")[1];
      this.postAxios("/newfloor/edit", {
        id: id,
        name: this.detailData.name, //楼盘名字
        quxian: this.detailData.quxian, //区县
        bieming: this.detailData.bieming, //别名
        shangquan: this.detailData.shangquan, //商圈
        huanxianId: Number(this.detailData.huanxianId), //环线 id，对应字典表【下拉框】
        address: this.detailData.address, //楼盘地址
        phone: this.detailData.phone, //售楼处电话
        zhuzhaileiId: Number(this.detailData.zhuzhaileiId), //住宅类别【下拉框】
        jianzhulouId: Number(this.detailData.jianzhulouId), //建筑类别（楼样式），对应字典表【下拉框】
        jianzhulouOther: this.detailData.jianzhulouOther, //建筑类别（其他）“其他”说明
        bieshuTypeId: Number(this.detailData.bieshuTypeId), //别墅建筑类别【下拉框】
        bieshuTypeOther: this.detailData.bieshuTypeOther, //别墅建筑类别“其他”说明
        bieshuFenggeId: Number(this.detailData.bieshuFenggeId), //别墅风格（字典表）【下拉框】
        miaoshu: this.detailData.miaoshu, //物业描述
        jianjie: this.detailData.jianjie, //项目简介
        chanquanId: Number(this.detailData.chanquanId), //产权年限（字典表）
        chanquanMiaoshu: this.detailData.chanquanMiaoshu, //产权描述
        zhandiMianji: this.detailData.zhandiMianji, //占地面积，平方米
        jianzhuMianji: this.detailData.jianzhuMianji, //建筑面积，苹方米
        rongji: this.detailData.rongji, //容积率
        lvhua: this.detailData.lvhua, //绿化率
        loudong: Number(this.detailData.loudong), //楼栋数
        zonghu: Number(this.detailData.zonghu), //总户数
        kaifa: this.detailData.kaifa, //已开发期数
        dangqian: this.detailData.dangqian, //当前期数
        zhuangkuang: this.detailData.zhuangkuang, //楼层状况
        chewei: this.detailData.chewei, //车位数量+车位描述
        cheweiChushou: this.detailData.cheweiChushou, //车位出售价格
        cheweiChuzu: this.detailData.cheweiChuzu, //车位出租价格
        wuyefei: this.detailData.wuyefei, //物业费 单位：元/月
        zhuangxiuId: Number(this.detailData.zhuangxiuId), //装修状况（字段表）【下拉框】
        longitude: this.detailData.longitude, //坐标-经度
        latitude: this.detailData.latitude, //坐标-纬度
        gongdian: this.detailData.gongdian, //供电
        jiegou: this.detailData.jiegou, //结构
        gongqi: this.detailData.gongqi, //供气
        waiqiang: this.detailData.waiqiang, //外墙
        cainuan: this.detailData.cainuan, //采暖
        neiqiang: this.detailData.neiqiang, //内墙
        dianti: this.detailData.dianti, //电梯
        tongxun: this.detailData.tongxun, //通讯
        hushu: this.detailData.hushu, //电梯服务户数
        menchuang: this.detailData.menchuang, //门窗
        weishengjian: this.detailData.weishengjian, //卫生间
        datang: this.detailData.datang, //大堂
        chufang: this.detailData.chufang, //厨房
        qiangmian: this.detailData.qiangmian, //首层大堂墙面
        dimian: this.detailData.dimian, //卧室地面
        cailiao: this.detailData.cailiao, //地面材料
        diantijian: this.detailData.diantijian, //电梯间
        tuliao: this.detailData.tuliao, //室内涂料
        zoulang: this.detailData.zoulang, //公共走廊，消防楼
        menjin: this.detailData.menjin, //门禁
        tiQiangmian: this.detailData.tiQiangmian, //电梯间墙面
        xinbaoxiang: this.detailData.xinbaoxiang, //信报箱
        dianshi: this.detailData.dianshi, //电视系统
        zhongshui: this.detailData.zhongshui, //中水系统
        kongtiao: this.detailData.kongtiao, //空调系统
        anfang: this.detailData.anfang, //安防系统
        weilan: this.detailData.weilan, //电子围栏
        jiaotong: this.detailData.jiaotong, //交通
        zhoubian: this.detailData.zhoubian, //周边设施
        neibu: this.detailData.neibu, //小区内部配套
        xiaoshouId: Number(this.detailData.xiaoshouId), //销售状态（字典表）【下拉框】
        jieduanId: Number(this.detailData.jieduanId), //销售阶段（字段表）【下拉框】
        kaigong: this.formatDateTime(this.detailData.kaigong), //开工时间
        jungong: this.formatDateTime(this.detailData.jungong), //竣工时间
        kaipan: this.formatDateTime(this.detailData.kaipan), //开盘时间
        ruzhu: this.formatDateTime(this.detailData.ruzhu), //入住时间
        shoulou: this.detailData.shoulou, //售楼地址
        linshi: this.detailData.linshi, //临时售楼地址

        bankId: Number(this.detailData.bankId), //按揭银行 id（字典表
        junjia: this.detailData.junjia, //均价
        zuidi: this.detailData.zuidi, //最低价
        cankao: this.detailData.cankao, //参考均价
        jiagemiao: this.detailData.jiagemiao, //价格描述
        baojiaDate: this.formatDateTime(this.detailData.baojiaDate), //报价日期
        zhekou: this.detailData.zhekou, //当前折扣

        kaifashang: this.detailData.kaifashang, //开发商
        touzishang: this.detailData.touzishang, //投资商
        wuyegongsi: this.detailData.wuyegongsi, //物业公司
        guwengongsi: this.detailData.guwengongsi, //物业顾问公司
        yuanlindanwei: this.detailData.yuanlindanwei, //建筑及园林设计单位
        chengjianshang: this.detailData.chengjianshang, //承建商
        dailishang: this.detailData.dailishang, //代理商
        jingguansheiji: this.detailData.jingguansheiji, //景观设计单位
        tuiguang: this.detailData.tuiguang, //整合推广单位
        pingmianmeiti: this.detailData.pingmianmeiti, //平面媒体广告单位
        biaoqian: this.detailData.biaoqian, //标签
        floorType: Number(this.detailData.floorType), //封面图片类型 1一张小图 2三张小图 3一张大图
        isRotation: this.detailData.isRotation, //1 轮播，2 置顶
        jianzhucengOther: this.detailData.jianzhucengOther, //建筑类别（层样式）
        zuigao: this.detailData.zuigao, //最高
        isLike: this.detailData.isLike, //是否推荐猜你喜欢 0不推荐 1推荐
        jianzhucengId: this.detailData.jianzhucengId, //建筑类别（层样式）（字典表）
        score: this.detailData.score, //评分
      }).then((res) => {
        if (res.success == true) {
          this.$message.success("保存成功");
          this.disOpen = true;
          document.getElementById("tipinput").value = "";
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },

    handleSuccess(file, fileList) {}, //上传成功
    //转base64
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file.raw);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },
    //上传对象转数组
    objToArr(obj) {
      var arr = [];
      for (var i in obj) {
        var newObj = {};
        newObj[i] = obj[i];
        arr.push(newObj);
      }
      return arr;
    },
    handleHouseSuccess(res, file) {
      this.imgHouse = URL.createObjectURL(file.raw);
    },

    //户型新增上传图片
    handlehouseUpt(file, fileList) {
      var id = this.Detaildata;
      // var res = this.getBase64(file);
      //讲上传的banner图转base64格式
      this.getBase64(file).then((resBase64) => {
        this.houseUrl.push(resBase64);
        if (this.houseUrl) {
          this.postAxios("/file/uploadBase64/v2", {
            resourceType: "FLOOR_FLOOHOUSE_IMGURL",
            fileList: this.houseUrl,
            id: id,
          }).then((res) => {
            if (res.success == true) {
              this.houseUptImg = res.content[0];
              this.houseUrl = [];
              this.$message.success("上传成功");
            } else if (res.success == false) {
              this.$message.error(res.message);
            }
            if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            }
          });
        }
      });
    },
    //*********************** */
    objOfValueToArr(object) {
      var arr = [];
      var i = 0;
      for (var item in object) {
        arr[i] = object[item];
        i++;
      }
      return arr;
    },
    removeFeng(file, fileList) {
      fengList = fileList;
    },
    removeZhou(file, fileList) {
      zhouList = fileList;
    },
    removeXian(file, fileList) {
      xianList = fileList;
    },
    removeYang(file, fileList) {
      yangList = fileList;
    },
    removeXiao(file, fileList) {
      xiaoList = fileList;
    },
    removeShi(file, fileList) {
      shiList = fileList;
    },
    removeWai(file, fileList) {
      waiList = fileList;
    },
    removeJiao(file, fileList) {
      jiaoList = fileList;
    },
    removeLun(file, fileList) {
      lunList = fileList;
    },

    //封面图上传
    handleFengUpt(file, fileList) {
      var id = this.Detaildata;
      fengList = fileList;
    },
    FengUpt() {
      fengList.map((i) => {
        this.getBase64(i).then((resBase64) => {
          this.objOfValueToArr(this.fengUrl);
          this.fengUrl.push(resBase64);
        });
      });

      setTimeout(() => {
        this.postFeng();
      }, 1000);
    },
    postFeng() {
      var id = this.Detaildata;
      if (fengList.length >= 1) {
        this.postAxios("/file/uploadBase64/v2", {
          resourceType: "FLOOR_FLOORIMG_TYPE_9",
          // fileList: this.objToArr(this.fengUrl)[0]
          fileList: this.fengUrl,
          id: id,
        }).then((res) => {
          if (res.success == true) {
            var arr = [];
            res.content.map((i) => {
              arr.push({
                imgName: "封面图",
                imgUrl: i,
                imgType: "9",
                floorId: id,
              });
            });
            this.phoneAdd(arr);
            this.fengUrl = [];
            fengList = [];
            this.$refs.fengImg.clearFiles();
          } else if (res.success == false) {
            this.$message.error(res.message);
          }
          if (!res.success && res.statusCode == "401") {
            this.$message.error(res.message);
            this.$router.push("/");
          }
        });
      }
    },
    //周边图上传
    handlezhouUpt(file, fileList) {
      zhouList = fileList;
    },
    ZhouUpt() {
      zhouList.map((i) => {
        this.getBase64(i).then((resBase64) => {
          this.objOfValueToArr(this.zhouUrl);
          this.zhouUrl.push(resBase64);
        });
      });

      setTimeout(() => {
        this.postZhou();
      }, 1000);
    },
    postZhou() {
      var id = this.Detaildata;
      if (zhouList.length >= 1) {
        this.postAxios("/file/uploadBase64/v2", {
          resourceType: "FLOOR_FLOORIMG_TYPE_8",
          fileList: this.zhouUrl,
          id: id,
        }).then((res) => {
          if (res.success == true) {
            var arr = [];
            res.content.map((i) => {
              arr.push({
                imgName: "周边配套图",
                imgUrl: i,
                imgType: "8",
                floorId: id,
              });
            });
            this.phoneAdd(arr);
            this.zhouUrl = [];
            zhouList = [];
            this.$refs.zhouImg.clearFiles();
          } else if (res.success == false) {
            this.$message.error(res.message);
          }
          if (!res.success && res.statusCode == "401") {
            this.$message.error(res.message);
            this.$router.push("/");
          }
        });
      }
    },

    //现场图上传
    handlexianUpt(file, fileList) {
      var id = this.Detaildata;
      xianList = fileList;
    },
    XianUpt() {
      xianList.map((i) => {
        this.getBase64(i).then((resBase64) => {
          this.objOfValueToArr(this.xianUrl);
          this.xianUrl.push(resBase64);
        });
      });

      setTimeout(() => {
        this.postXian();
      }, 1000);
    },
    postXian() {
      var id = this.Detaildata;
      if (xianList.length >= 1) {
        this.postAxios("/file/uploadBase64/v2", {
          resourceType: "FLOOR_FLOORIMG_TYPE_7",
          fileList: this.xianUrl,
          id: id,
        }).then((res) => {
          if (res.success == true) {
            var arr = [];
            res.content.map((i) => {
              arr.push({
                imgName: "现场项目图",
                imgUrl: i,
                imgType: "7",
                floorId: id,
              });
            });
            this.phoneAdd(arr);
            this.xianUrl = [];
            xianList = [];
            this.$refs.xianImg.clearFiles();
          } else if (res.success == false) {
            this.$message.error(res.message);
          }
          if (!res.success && res.statusCode == "401") {
            this.$message.error(res.message);
            this.$router.push("/");
          }
        });
      }
    },
    //样板图图上传
    handleyangUpt(file, fileList) {
      yangList = fileList;
    },
    YangUpt() {
      yangList.map((i) => {
        this.getBase64(i).then((resBase64) => {
          this.objOfValueToArr(this.yangUrl);
          this.yangUrl.push(resBase64);
        });
      });

      setTimeout(() => {
        this.postYang();
      }, 1000);
    },
    postYang() {
      var id = this.Detaildata;
      if (yangList.length >= 1) {
        this.postAxios("/file/uploadBase64/v2", {
          resourceType: "FLOOR_FLOORIMG_TYPE_6",
          fileList: this.yangUrl,
          id: id,
        }).then((res) => {
          if (res.success == true) {
            var arr = [];
            res.content.map((i) => {
              arr.push({
                imgName: "样板间图",
                imgUrl: i,
                imgType: "6",
                floorId: id,
              });
            });
            this.phoneAdd(arr);
            this.yangUrl = [];
            yangList = [];
            this.$refs.yangImg.clearFiles();
          } else if (res.success == false) {
            this.$message.error(res.message);
          } else if (!res.success && res.statusCode == "401") {
            this.$message.error(res.message);
            this.$router.push("/");
          }
        });
      }
    },
    //效果图上传
    handlexiaoUpt(file, fileList) {
      xiaoList = fileList;
    },

    XiaoUpt() {
      xiaoList.map((i) => {
        this.getBase64(i).then((resBase64) => {
          this.objOfValueToArr(this.xiaoUrl);
          this.xiaoUrl.push(resBase64);
        });
      });

      setTimeout(() => {
        this.postXiao();
      }, 1000);
    },
    postXiao() {
      var id = this.Detaildata;
      if (xiaoList.length >= 1) {
        this.postAxios("/file/uploadBase64/v2", {
          resourceType: "FLOOR_FLOORIMG_TYPE_5",
          fileList: this.xiaoUrl,
          id: id,
        }).then((res) => {
          if (res.success == true) {
            var arr = [];
            res.content.map((i) => {
              arr.push({
                imgName: "效果图",
                imgUrl: i,
                imgType: "5",
                floorId: id,
              });
            });
            this.phoneAdd(arr);
            this.xiaoUrl = [];
            xiaoList = [];
            this.$refs.xiaoImg.clearFiles();
          } else if (res.success == false) {
            this.$message.error(res.message);
          } else if (!res.success && res.statusCode == "401") {
            this.$message.error(res.message);
            this.$router.push("/");
          }
        });
      }
    },
    //实景图上传
    handleshiUpt(file, fileList) {
      shiList = fileList;
    },
    ShiUpt() {
      shiList.map((i) => {
        this.getBase64(i).then((resBase64) => {
          this.objOfValueToArr(this.shiUrl);
          this.shiUrl.push(resBase64);
        });
      });

      setTimeout(() => {
        this.postShi();
      }, 1000);
    },
    postShi() {
      var id = this.Detaildata;
      if (shiList.length >= 1) {
        this.postAxios("/file/uploadBase64/v2", {
          resourceType: "FLOOR_FLOORIMG_TYPE_4",
          fileList: this.shiUrl,
          id: id,
        }).then((res) => {
          if (res.success == true) {
            var arr = [];
            res.content.map((i) => {
              arr.push({
                imgName: "实景图",
                imgUrl: i,
                imgType: "4",
                floorId: id,
              });
            });
            this.phoneAdd(arr);
            this.shiUrl = [];
            shiList = [];
            this.$refs.shiImg.clearFiles();
          } else if (res.success == false) {
            this.$message.error(res.message);
          } else if (!res.success && res.statusCode == "401") {
            this.$message.error(res.message);
            this.$router.push("/");
          }
        });
      }
    },
    //外景图上传
    handlewaiUpt(file, fileList) {
      waiList = fileList;
    },
    WaiUpt() {
      waiList.map((i) => {
        this.getBase64(i).then((resBase64) => {
          this.objOfValueToArr(this.waiUrl);
          this.waiUrl.push(resBase64);
        });
      });

      setTimeout(() => {
        this.postWai();
      }, 1000);
    },
    postWai() {
      var id = this.Detaildata;
      if (waiList.length >= 1) {
        this.postAxios("/file/uploadBase64/v2", {
          resourceType: "FLOOR_FLOORIMG_TYPE_3",
          fileList: this.waiUrl,
          id: id,
        }).then((res) => {
          if (res.success == true) {
            var arr = [];
            res.content.map((i) => {
              arr.push({
                imgName: "外景图",
                imgUrl: i,
                imgType: "3",
                floorId: id,
              });
            });
            this.phoneAdd(arr);
            this.waiUrl = [];
            waiList = [];
            this.$refs.waiImg.clearFiles();
          } else if (res.success == false) {
            this.$message.error(res.message);
          } else if (!res.success && res.statusCode == "401") {
            this.$message.error(res.message);
            this.$router.push("/");
          }
        });
      }
    },
    //交通图上传
    handlejiaoUpt(file, fileList) {
      jiaoList = fileList;
    },
    JiaoUpt() {
      jiaoList.map((i) => {
        this.getBase64(i).then((resBase64) => {
          this.objOfValueToArr(this.jiaoUrl);
          this.jiaoUrl.push(resBase64);
        });
      });

      setTimeout(() => {
        this.postJiao();
      }, 1000);
    },
    postJiao() {
      var id = this.Detaildata;
      if (jiaoList.length >= 1) {
        this.postAxios("/file/uploadBase64/v2", {
          resourceType: "FLOOR_FLOORIMG_TYPE_2",
          fileList: this.jiaoUrl,
          id: id,
        }).then((res) => {
          if (res.success == true) {
            var arr = [];
            res.content.map((i) => {
              arr.push({
                imgName: "交通图",
                imgUrl: i,
                imgType: "2",
                floorId: id,
              });
            });
            this.phoneAdd(arr);
            this.jiaoUrl = [];
            jiaoList = [];
            this.$refs.jiaoImg.clearFiles();
          } else if (res.success == false) {
            this.$message.error(res.message);
          } else if (!res.success && res.statusCode == "401") {
            this.$message.error(res.message);
            this.$router.push("/");
          }
        });
      }
    },
    //轮播图上传
    handlelunUpt(file, fileList) {
      lunList = fileList;
    },
    LunUpt() {
      lunList.map((i) => {
        this.getBase64(i).then((resBase64) => {
          this.objOfValueToArr(this.lunUrl);
          this.lunUrl.push(resBase64);
        });
      });

      setTimeout(() => {
        this.postLun();
      }, 1000);
    },
    postLun() {
      var id = this.Detaildata;
      if (lunList.length >= 1) {
        this.postAxios("/file/uploadBase64/v2", {
          resourceType: "FLOOR_FLOORIMG_TYPE_1",
          fileList: this.lunUrl,
          id: id,
        }).then((res) => {
          if (res.success == true) {
            var arr = [];
            res.content.map((i) => {
              arr.push({
                imgName: "轮播图",
                imgUrl: i,
                imgType: "1",
                floorId: id,
              });
            });
            this.phoneAdd(arr);
            this.lunUrl = [];
            lunList = [];
            this.$refs.lunImg.clearFiles();
          } else if (res.success == false) {
            this.$message.error(res.message);
          } else if (!res.success && res.statusCode == "401") {
            this.$message.error(res.message);
            this.$router.push("/");
          }
        });
      }
    },

    //上传图限制提示
    handleExceed(files, fileList) {
      this.$message.warning(`当前图片限制1张`);
    },
    //删除上传图
    // removeBanner(file, fileList) {
    //   var res = this.getBase64(file);
    //   this.houseUptImg = "";
    //   this.fengUptImg = "";
    //   this.zhouUptImg = "";
    //   this.xianUptImg = "";
    //   this.yangUptImg = "";
    //   this.lunUptImg = ""; //轮播
    //   this.xiaoUptImg = ""; //效果图
    //   this.shiUptImg = ""; //实景图
    //   this.waiUptImg = ""; //外景图
    //   this.jiaoUptImg = ""; //交通图
    //   this.$refs.lunImg.clearFiles();
    //   //* 1. 获取将要删除的图片的临时路径
    //   const { tmp_path } = file.response;
    //   //* 2. 从 pics 数组中，找到这个图片对应的索引值
    //   const i = this.lunUrl.findIndex((item) => item == tmp_path);
    //   //* 3. 调用数组的splice方法，把图片信息对象，从pics数组中移除
    //   this.lunUrl.splice(i, 1);
    // },
    //详情列表的数据
    init() {
      var id = this.Detaildata;

      this.getAxios(`/newfloor/detail/${id}`).then((res) => {
        if (res.success == true) {
          this.detailData = res.entity;
          this.detailData.isLike = Number(res.entity.isLike);
          this.detailData.isHot = Number(res.entity.isHot);
          this.detailData.isRotation = Number(res.entity.isRotation);
          this.detailData.quxian = Number(res.entity.quxian);
          this.floorName = res.entity.name;
          this.initMap();
        }

        if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //销售的数据
    salesLicense() {
      var id = this.Detaildata;
      this.getAxios("/newfloor/list/salesLicense", {
        floorId: id,
      }).then((res) => {
        if (res.success == true) {
          this.salesDatas = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //销售保存
    handleOk() {
      var id = this.Detaildata;
      this.postAxios("/newfloor/add/salesLicense", {
        //添加数据
        salesNumber: this.moreDatas.salesNumber, //许可证号
        bindBuiding: this.moreDatas.bindBuiding, //绑定的楼号
        floorId: id, //bindBuiding
      }).then((res) => {
        if (res.success == true) {
          this.salesLicense();
          this.moreDatas.salesNumber = "";
          this.moreDatas.bindBuiding = "";
          this.$message.success("添加成功");
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
      this.sclasvalibity = false;
    },
    handleCancel() {
      this.sclasvalibity = false;
      this.messagealibity = false;
    },
    //销售添加数据
    xiaoAdd() {
      this.sclasvalibity = true;
    },
    //新增之后无数据弹框出现
    xiaoAdd() {
      this.sclasvalibity = true;
    },

    //销售删除数据
    handleDetail(ids) {
      this.getAxios("/newfloor/delete/salesLicense", {
        id: ids,
      }).then((res) => {
        if (res.success == true) {
          this.salesLicense();
          this.$message.success("删除成功");
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    //户型数据
    houseInit() {
      var id = this.Detaildata;
      this.getAxios(`/floorHouse/list/${id}`, {}).then((res) => {
        if (res.success == true) {
          this.houseDatas = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //户型新增
    houseAdd() {
      this.houseOpen = true;
      this.imgHouse = require("../../assets/upt.jpg");
      this.houseUrl = [];
      this.houseUptImg = [];
    },
    //户型无数据添加
    huAdd() {
      this.houseOpen = true;
    },
    //确认新增
    submitAdd() {
      var id = this.Detaildata;
      this.postAxios("/floorHouse/insert", {
        imgUrl: this.houseUptImg, //封面图的 url，这里传一个 ossurl
        room: this.houseAddDatas.room, //室的数量
        office: this.houseAddDatas.office, //厅的数量
        toilet: this.houseAddDatas.toilet, //卫生间的数量
        price: this.houseAddDatas.price, //价格
        size: this.houseAddDatas.size, //面积
        branch: "",
        floorName: this.floorName,
        floorId: id,
      }).then((res) => {
        if (res.success == true) {
          this.$message.success("新增成功");
          this.houseInit();
          this.houseOpen = false;
          //清空新增弹框：
          this.houseUptImg = [];
          this.houseAddDatas.room = "";
          this.houseAddDatas.office = "";
          this.houseAddDatas.toilet = "";
          this.houseAddDatas.price = "";
          this.houseAddDatas.size = "";
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    //户型删除
    houseDel(id) {
      this.getAxios(`/floorHouse/delete/${id}`, {}).then((res) => {
        if (res.success == true) {
          this.houseInit();
          this.$message.success("删除成功");
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    //置业经理数据
    manageInit() {
      var id = this.Detaildata;
      this.getAxios("/newfloor/list/salesman", {
        floorId: id,
      }).then((res) => {
        if (res.success == true) {
          this.manageDatas = res.content.filter(function (item) {
            return item.floorId != null;
          });
          this.manageName = res.content.filter(function (item) {
            return item.floorId == null;
          });
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //置业添加弹框
    messAdd(ids, ind) {
      this.messId = ids;

      this.inds = ind;
    },
    //置业添加弹框确定
    handleYes() {
      var id = this.Detaildata;
      this.postAxios("/newfloor/add/salesman", {
        floorId: id,
        salesmanId: this.messId,
      }).then((res) => {
        if (res.success == true) {
          this.manageInit();
          this.$message.success("添加成功");
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
      this.messagealibity = false;
    },
    //置业经理弹框
    handleZhi() {
      this.messagealibity = true;
    },
    //置业删除
    zhiDel(zhiId) {
      var id = this.Detaildata;
      this.getAxios("/newfloor/delete/salesman", {
        floorId: id,
        salesmanId: zhiId,
      }).then((res) => {
        if (res.success == true) {
          this.manageInit();
          this.$message.success("删除成功");
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    //楼盘相册的数据
    phoneInit() {
      var id = this.Detaildata;
      this.getAxios("/newfloorImg/list", {
        floorId: id,
      }).then((res) => {
        if (res.success == true) {
          this.imgFeng = res.content.filter(function (item) {
            return item.imgType == 9;
          }); //封面图
          this.imgZhou = res.content.filter(function (item) {
            return item.imgType == 8;
          }); //周边图
          this.imgXian = res.content.filter(function (item) {
            return item.imgType == 7;
          }); //现场图
          this.imgYang = res.content.filter(function (item) {
            return item.imgType == 6;
          }); //样板间图
          this.imgXiao = res.content.filter(function (item) {
            return item.imgType == 5;
          }); //效果图
          this.imgShi = res.content.filter(function (item) {
            return item.imgType == 4;
          }); //实景图
          this.imgWai = res.content.filter(function (item) {
            return item.imgType == 3;
          }); //外景图
          this.imgJiao = res.content.filter(function (item) {
            return item.imgType == 2;
          }); //交通图
          this.imgLun = res.content.filter(function (item) {
            return item.imgType == 1;
          }); //轮播图
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //相册新增：
    phoneAdd(obj) {
      this.postAxios("/newfloorImg/insert", obj).then((res) => {
        if (res.success == true) {
          this.phoneInit();
          this.$message.success("新增成功");
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    //相册删除
    phoneDel(id) {
      //相册删除
      this.getAxios(`/newfloorImg/delete/${id}`, {}).then((res) => {
        if (res.success == true) {
          this.phoneInit();
          this.$message.success("删除成功！");
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    floorInit() {
      //楼盘动态的数据
      var id = this.Detaildata;
      this.getAxios("/newfloor/list/activity", {
        floorId: id,
      }).then((res) => {
        if (res.success == true) {
          this.floorDatas = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //楼层删除
    floorDel(id) {
      this.getAxios("/newfloor/delete/activity", {
        activityId: id,
      }).then((res) => {
        if (res.success == true) {
          this.$message.success("删除成功！");
          this.floorInit();
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    //楼层新增
    floorAdd() {
      this.flooraddOpen = true;
    },
    //楼层没数据时新增
    louAdd() {
      this.flooraddOpen = true;
    },
    //新增内容保存
    floorQue() {
      var id = this.Detaildata;
      this.postAxios("/newfloor/add/activity", {
        tag: this.flooraddData.tag, //标签
        title: this.flooraddData.title, //标题
        message: this.flooraddData.message, //内容
        floorId: id,
      }).then((res) => {
        if (res.success == true) {
          this.floorInit();
          this.flooraddOpen = false;
          this.flooraddData.title = ""; //标签
          this.flooraddData.tag = ""; //标题
          this.flooraddData.message = ""; //内容
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    // 地铁=============================================
    //获取数据：
    carInit(hor) {
      this.carData=[];
      var id = this.Detaildata;
      this.getAxios("/newfloor/list/metro", {
        floorId: id,
        metroNumber: hor,
      }).then((res) => {
        if (res.success == true) {
          this.carData = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //几号线路线：
    initCar() {
      this.getAxios("/metro/list", {}).then((res) => {
        if (res.success == true) {
          this.horData = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //点击切换站点
    handleCar(name, ind) {
      this.selectLi = ind;
      this.carOpen = true;
      this.cars = name.substr(0, 1);
      localStorage.setItem("cars", this.cars);
      this.carInit(this.cars);
    },
    //删除地铁：
    handleDel(ids) {
      var that = this;
      var id = this.Detaildata;
      this.getAxios("/newfloor/delete/metro", {
        floorId: id,
        metroId: ids,
      }).then((res) => {
        if (res.success == true) {
          var cars = localStorage.getItem("cars");
          this.carInit(cars);
          this.$message.success("删除成功");
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    //添加地铁：
    handleAdd(ids) {
      var that = this;
      var id = this.Detaildata;
      this.postAxios("/newfloor/add/metro", {
        floorId: id,
        metroId: ids,
      }).then((res) => {
        if (res.success == true) {
          var cars = localStorage.getItem("cars");
          this.carInit(cars);
          this.$message.success("添加成功");
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },

    // ========下拉数据========
    //区县：
    selectQu() {
      var that = this;
      this.getAxios(`/dic/list/tianjinquxian`, {}).then((res) => {
        if (res.success == true) {
          this.quData = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //环线：huanxian
    handleHuan() {
      this.getAxios(`/dic/list/huanxian`, {}).then((res) => {
        if (res.success == true) {
          this.huanData = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //住宅
    handleZhu() {
      this.getAxios(`/dic/list/zhuzhai`, {}).then((res) => {
        if (res.success == true) {
          this.zhuData = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //建筑类别
    handleJian() {
      this.getAxios(`/dic/list/zhuzhailouxing`, {}).then((res) => {
        if (res.success == true) {
          this.jianData = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //建筑类别（层样式）（字典表）【下拉框】
    hanldeZhu() {
      this.getAxios(`/dic/list/cengxing`, {}).then((res) => {
        if (res.success == true) {
          this.leiData = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //别墅建筑类别【下拉框】
    handleBie() {
      this.getAxios(`/dic/list/bieshuliebie`, {}).then((res) => {
        if (res.success == true) {
          this.bieData = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //别墅风格（字典表）【下拉框】
    handleShu() {
      this.getAxios(`/dic/list/bieshufengge`, {}).then((res) => {
        if (res.success == true) {
          this.shuData = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //装修状况（字段表）【下拉框】
    handleXiu() {
      this.getAxios(`/dic/list/zhuangxiuzhuangkuang`, {}).then((res) => {
        if (res.success == true) {
          this.xiuData = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //销售状态（字典表）【下拉框】
    handleXiao() {
      this.getAxios(`/dic/list/xiaoshoustatus`, {}).then((res) => {
        if (res.success == true) {
          this.xiaotai = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //销售阶段（字段表）【下拉框】
    handleShou() {
      this.getAxios(`/dic/list/xiaoshoujieduan`, {}).then((res) => {
        if (res.success == true) {
          this.xiaoData = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //按揭银行 id（字典表）【下拉框】
    handleJie() {
      this.getAxios(`/dic/list/anjiebank`, {}).then((res) => {
        if (res.success == true) {
          this.jieData = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //产权年限【下拉框】
    handlechanData() {
      this.getAxios(`/dic/list/chanquan`, {}).then((res) => {
        if (res.success == true) {
          this.chanData = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },

    initMap() {
      var map = new AMap.Map("container", {
        zoom: 17, //级别
        mapStyle: "amap://styles/macaron", //设置地图的显示样式
        pitch: 70, // 地图俯仰角度，有效范围 0 度- 83 度
        center: [this.detailData.longitude, this.detailData.latitude], //中心点坐标
        zoomEnable: false,
        dragEnable: false,
      });
      var marker = new AMap.Marker({
        position: new AMap.LngLat(
          this.detailData.longitude,
          this.detailData.latitude
        ),
        // icon: "//vdata.amap.com/icons/b18/1/2.png", // 添加 Icon 图标 URL
      });
      map.add(marker);
      document.getElementById("lnglat").value =
        this.detailData.longitude + "," + this.detailData.latitude;
      // var title = `<span style="font-size:15px;color:#1890ff;font-weight:bold">${this.address}</span>`;

      var infoWindow = new AMap.InfoWindow({
        anchor: "bottom-left",
        // content: title,
      });

      infoWindow.open(map, [
        this.detailData.longitude,
        this.detailData.latitude,
      ]);
      map.clearInfoWindow();
      //鼠标点击marker弹出自定义的信息窗体
      AMap.event.addListener(marker, "click", function () {
        infoWindow.open(map, marker.getPosition());
      });

      AMap.plugin(["AMap.Autocomplete", "AMap.PlaceSearch"], function () {
        var autoOptions = {
          city: "天津",
          input: "tipinput", //使用联想输入的input的id（也就是上边那个唯一的id）
        };
        var autocomplete = new AMap.Autocomplete(autoOptions);
        var placeSearch = new AMap.PlaceSearch({
          map: map,
        });
        AMap.event.addListener(autocomplete, "select", function (e) {
          //TODO 针对选中的poi实现自己的功能
          placeSearch.setCity(e.poi.adcode);
          placeSearch.search(e.poi.name);
          document.getElementById("lnglat").value =
            e.poi.location.lng + "," + e.poi.location.lat;
        });
      });
    },
  },
  created() {
    this.init(); //详情列表的数据
    this.salesLicense(); //销售的数据
    this.houseInit(); //户型数据
    this.manageInit(); //置业经理数据
    this.phoneInit(); //楼盘相册的数据
    this.floorInit(); //楼盘动态的数据
    this.carInit(1); //地铁的数据
    this.initCar(); //地铁号线的数据

    // ============下拉框===========
    this.selectQu(); //区县
    this.handleHuan(); //环线
    this.handleZhu(); //住宅
    this.handleJian(); ////建筑类别
    this.hanldeZhu(); ////建筑类别（层样式）（字典表）【下拉框】
    this.handleBie(); // //别墅建筑类别【下拉框】
    this.handleShu(); // //别墅风格（字典表）【下拉框】
    this.handleXiu(); //装修状况（字段表）【下拉框】
    this.handleXiao(); //销售状态（字典表）【下拉框】
    this.handleShou(); //销售阶段（字段表）【下拉框】
    this.handleJie(); //按揭银行 id（字典表）【下拉框】
    this.handlechanData(); //产权年限【下拉框】

    //更改类型
  },
  watch: {
    Detaildata(newVal, oldVal) {
      this.init();

      this.salesLicense(); //销售的数据
      this.houseInit(); //户型数据
      this.manageInit(); //置业经理数据
      this.phoneInit(); //楼盘相册的数据
      this.floorInit(); //楼盘动态的数据
      this.carInit(1); //地铁的数据
      this.selectLi=0
      // this.initCar(); //地铁号线的数据
    },
  },
};
</script>
<style scoped lang="less">
.houseDetail {
  width: 100%;
  height: 100%;

  // width: 95%;
  // margin: 0 auto;
  // margin-top: 30px;
  .el-table {
    border: 1px solid #eee;
    width: 100%;
    height: auto;
  }

  .quxian {
    width: 200px;
    height: 32px;
    line-height: 32px;
    border: 1px solid #eee;
    border-radius: 5px;
  }

  .house_box {
    width: 100%;
    display: flex;
    flex-shrink: 3;
    flex-wrap: wrap;
    .house_one {
      width: 200px;
      height: auto;
      border: 1px solid #eee;
      margin-left: 20px;
      .house_img {
        width: 100%;
        height: 150px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .house_message {
        width: 100%;
        .el-row {
          margin-left: 15px;
          height: 50px;
          line-height: 50px;
          .el-button--primary {
            width: 80px;
          }
        }
      }
    }
    .house_add {
      width: 220px;
      height: 350px;
      border: 1px solid #eee;
      margin-left: 20px;

      .house_img {
        width: 100%;
        height: 150px;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
        .avatar-uploader .el-upload {
          border: 1px dashed #d9d9d9;
          border-radius: 6px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }
        .avatar-uploader .el-upload:hover {
          border-color: #409eff;
        }
        .avatar-uploader-icon {
          font-size: 28px;
          color: #8c939d;
          width: 215px;
          height: 150px;
          line-height: 150px;
          text-align: center;
        }
        .avatar {
          width: 215px;
          height: 150px;
          display: block;
        }
        /deep/ .el-upload--picture-card {
          background-color: #fbfdff;
          border: 1px dashed #c0ccda;
          border-radius: 6px;
          box-sizing: border-box;
          width: 148px;
          height: 148px;
          line-height: 146px;
          vertical-align: top;
          position: absolute;
          left: 15%;
          top: 0;
        }
        /deep/ .el-upload-list--picture-card .el-upload-list__item {
          overflow: hidden;
          background-color: #fff;
          border: 1px solid #c0ccda;
          border-radius: 6px;
          box-sizing: border-box;
          width: 148px;
          height: 148px;
          margin: 0 8px 8px 0;
          display: inline-block;
          margin-left: 15%;
        }
      }
      .house_message {
        width: 100%;
        .el-row {
          margin-left: 15px;
          height: 50px;
          line-height: 50px;
        }
      }
    }
  }
  .manage_box {
    width: 100%;

    display: flex;
    flex-shrink: 3;
    flex-wrap: wrap;
    margin-left: 100px;
    margin-top: 20px;

    .manage_one {
      width: 250px;
      height: 400px;
      border: 1px solid #eee;
      margin-left: 20px;

      .manage_img {
        width: 100px;
        height: 150px;
        margin: 0 auto;

        img {
          width: 100%;
          height: 150px;
        }
      }
      .manage_message {
        width: 100%;
        .el-row {
          margin-left: 15px;
          // height: 50px;
          line-height: 50px;
        }
      }
    }
  }
  .el-row {
    box-sizing: border-box;
    display: flex;
  }
  .logoUg {
    width: 150px;
    height: 150px;

    img {
      width: 100%;
      height: 100%;
    }
    &:hover {
      cursor: pointer;
      .delimg {
        display: block !important;
      }
    }
    .delimg {
      display: none;
    }
  }
  /deep/ .el-input.is-disabled .el-input__inner {
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    color: #c0c4cc;
    cursor: not-allowed;
    width: 200px;
  }
  /deep/ .houseDetail[data-v-387a614c] .el-input.is-disabled .el-input__inner {
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    color: #c0c4cc;
    cursor: not-allowed;
    width: 200px;
  }
  .car_box {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    .car_gui {
      width: 100%;
      height: 50px;
      line-height: 50px;
      display: flex;
      div {
        width: 50px;
        margin-left: 30px;
        font-size: 15px;
        font-weight: bold;
      }
      .on {
        color: red;
      }
    }
    .car_lu {
      width: 100%;
      height: auto;
      display: flex;
      border: 1px solid #eee;
      height: auto;
      flex-wrap: wrap;
      flex-shrink: 8;
      div {
        width: auto;
        height: 50px;
        line-height: 50px;
        margin-left: 30px;
        .active {
          color: red;
        }
      }
    }
  }
}
/deep/ .ant-modal-body {
  padding: 24px;
  font-size: 14px;
  line-height: 1.5;
  word-wrap: break-word;

  ul {
    height: 200px !important;
    overflow-y: scroll !important;
    li {
      height: 30px;
      line-height: 30px;
      border-bottom: 1px solid #eee;
    }
    .ons {
      // color: red;
      font-size: 24px;
      font-weight: bold;
      font-family: "华文行楷";

      background-image: -webkit-linear-gradient(left, #1890e0, #be0fa7);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
}
/deep/ .el-button--primary {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  width: 100px;
  // margin-top: 10px;
  // margin-left: 10px;
}
/deep/ .xmjj .el-input__inner {
  width: 958px !important;
  height: 60px;
}
/deep/ .el-form-item__content {
  margin-left: 0px !important;
  margin-bottom: 10px;
  margin-top: 10px;
}
/deep/ .el-form-item__label {
  margin-top: 12px;
}
#container {
  height: 300px;
  width: 1100px;
}
#tipinput {
  position: absolute;
  top: 0;
}
.input-card {
  position: absolute;
  right: 50px;
  bottom: 20px;
  background: #fff;
}
#lnglat {
  outline: 0;
  border: 0;
}
/deep/.setIpt input {
  width: 580px !important;
}
/deep/.setIpt textarea {
  width: 960px !important;
}
/deep/.ipt input {
  width: 960px !important;
}
.flexForm {
  display: flex;
}
/deep/ .flexForm .el-form-item__content {
  display: flex;
}
.upLoadBtn {
  margin-left: 138px;
  width: 80px !important;
}
</style>

